import { useEffect, useRef } from "react";
import { useStableCallback } from "./useStableCallback";

export const useIntersectionObserver = (
	ref: React.RefObject<HTMLElement>,
	callback: (entry: IntersectionObserverEntry) => void,
	options: IntersectionObserverInit = {},
) => {
	const observerRef = useRef<IntersectionObserver>();
	// Ne need to re-subscribe when callback changes
	const stableCallback = useStableCallback(callback);

	useEffect(() => {
		const handleIntersect: IntersectionObserverCallback = (entries) => {
			entries.forEach((entry) => {
				stableCallback(entry);
			});
		};

		observerRef.current?.disconnect();

		if (ref.current) {
			// Create new observer if depedencies changes and the have an element (ref)
			const observer = new IntersectionObserver(handleIntersect, options);
			observer.observe(ref.current);
			observerRef.current = observer;
		}
	}, [options.rootMargin, options.threshold, options.root, ref, stableCallback, options]);

	// Stop observing when component of hook is removed
	useEffect(() => {
		return () => {
			observerRef.current?.disconnect();
		};
	}, []);
};
